module["exports"] = [
  "ახალი",
  "ძველი",
  "ზემო",
  "ქვემო"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/ge/address/city_prefix.js
// module id = 1171
// module chunks = 1